<template>
  <FlexColumn :space="0">
    <Label text="キーワード" bold />
    <FlexColumn>
      <FlexRow align="center">
        <Label text="すべてを含む" style="width: 100px" />
        <TextField
            placeholder="スペース区切りでキーワード入力"
            :value="andKeyword"
            simple
            class="mt-0 pt-0"
            @input="handleInputAndKeyword"
        />
      </FlexRow>
      <FlexRow align="center">
        <Label text="いずれかを含む" style="width: 100px" />
        <TextField
            placeholder="スペース区切りでキーワード入力"
            :value="orKeyword"
            simple
            class="mt-0 pt-0"
            @input="handleInputOrKeyword"
        />
      </FlexRow>
    </FlexColumn>
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import FlexRow from "@/components/atoms/FlexRow";
import Label from "@/components/atoms/Label";
import TextField from "../atoms/TextField.vue";

export default {
  name: "ApplicantSearchKeywordsForm",
  components: {TextField, Label, FlexRow, FlexColumn},
  props: {
    andKeyword: {
      type: String,
    },
    orKeyword: {
      type: String,
    },
  },
  methods: {
    handleInputAndKeyword(value) {
      this.$emit('input', {andKeyword: value, orKeyword: this.orKeyword})
    },
    handleInputOrKeyword(value) {
      this.$emit('input', {andKeyword: this.andKeyword, orKeyword: value})
    },
  }
}
</script>

<style scoped>
>>> .input-type input {
  display: none;
}
</style>